import { FC } from "react";
import { useTranslation } from "react-i18next";
import InfoModal from "@/components/modal/info";
import useModalsStore from "@/stores/modals";
import { SoundOption, playSound } from "@/helpers/playSound";

const InvalidQrModal: FC = () => {
  const { t } = useTranslation();

  const { setInvalidQrModal } = useModalsStore();

  const finalClose = () => {
    setInvalidQrModal(false);
    playSound(SoundOption.Click2Lo);
  };

  return (
    <InfoModal
      onClose={finalClose}
      title={t("mainPage.invalidQrScan.title")}
      description={t("mainPage.invalidQrScan.message")}
      buttonText={t("ui.cancel")}
      testId="invalid-qr"
    />
  );
};

export default InvalidQrModal;
